/**
 * Determines the base URL for backend API calls.
 *
 * Uses `VITE_API_BASE_URL` when explicitly set; otherwise defaults to
 * same-origin, which works with both Vite dev proxy and Docker/nginx proxying.
 */
const envBase = (import.meta.env.VITE_API_BASE_URL as string | undefined)?.trim();
const runtimeDefaultBase =
  typeof window !== "undefined" ? window.location.origin : "http://localhost:3000";
const rawBase = envBase && envBase.length > 0 ? envBase : runtimeDefaultBase;

/**
 * Normalized API base URL without trailing slash.
 */
export const API_BASE_URL = rawBase.replace(/\/$/, "");
